import { render, staticRenderFns } from "./RiskProblemList.vue?vue&type=template&id=3897c9a6&scoped=true"
import script from "./RiskProblemList.vue?vue&type=script&lang=js"
export * from "./RiskProblemList.vue?vue&type=script&lang=js"
import style0 from "./RiskProblemList.vue?vue&type=style&index=0&id=3897c9a6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3897c9a6",
  null
  
)

export default component.exports